import script from "./UserGeolocation.vue?vue&type=script&setup=true&lang=js"
export * from "./UserGeolocation.vue?vue&type=script&setup=true&lang=js"

import "./UserGeolocation.vue?vue&type=style&index=0&id=5ff35644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff35644"]])

export default __exports__